import type { ApplyCoaTemplateEntitySelectionRow } from "./applyCoaTemplateEntitySelection.types";

// A selected entity resolved from the select-step tree, used by the preview's
// left panel (grouped by client) and to look up its per-entity preview payload.
export interface SelectedPreviewEntity {
    entityId: number;
    name: string;
    clientLabel: string;
    workspaceId: string;
    iconColor: string;
    logo: string | null;
}

// Resolves the selected applicable entity ids into ordered preview entries,
// grouping by their parent client (workspace) in tree order so the left panel
// matches the select step.
export function buildSelectedPreviewEntries({
    tableData,
    selectedApplicableEntityIds,
}: {
    tableData: ApplyCoaTemplateEntitySelectionRow[];
    selectedApplicableEntityIds: string[];
}): SelectedPreviewEntity[] {
    const selectedIds = new Set(selectedApplicableEntityIds);
    const entries: SelectedPreviewEntity[] = [];

    for (const workspaceRow of tableData) {
        for (const child of workspaceRow.children ?? []) {
            if (!selectedIds.has(child.id) || child.entityId === null) {
                continue;
            }
            entries.push({
                entityId: child.entityId,
                name: child.name,
                clientLabel: workspaceRow.name,
                workspaceId: child.workspaceId,
                iconColor: child.iconColor,
                logo: child.logo,
            });
        }
    }

    return entries;
}
